import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["rest-between-intervals"]!;

export function Body() {
  return (
    <>
      <p>
        In an interval session the rest between the hard parts is easy to cut short when time
        is tight. A Norwegian study looked at how much the length of the rest actually changes
        what you can run.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Nine well-trained male runners ran six repetitions of four minutes on a treadmill set
        to a 5 percent incline. They ran as fast as they could hold evenly across all six. On
        different days the rest between repetitions was one, two or four minutes. On a fourth
        day the runners chose the length of the rest themselves.
      </p>

      <h2>What they found</h2>
      <p>
        With two minutes of rest instead of one, the runners ran a little faster: 14.7 km/h on
        average instead of 14.4 km/h. Four minutes of rest did not make them faster than two.
        Their peak lactate was about the same in all versions, and the session felt slightly
        easier with four minutes of rest.
      </p>
      <p>
        When the runners chose the rest themselves, without knowing how long it had been, they
        took close to two minutes on average.
      </p>

      <h2>What it means for you</h2>
      <p>
        For intervals of about four minutes, around two minutes of easy jogging between
        repetitions seems to be enough. A longer rest makes the session feel easier but doesn't
        let you run much faster. A very short rest costs a little speed.
      </p>
      <p>
        If you are short of time, it is usually better to run fewer repetitions with proper
        rest than to squeeze the rests and keep all of them.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The study measured a single session, not how runners improve over weeks. It included
        nine well-trained men, ran on an incline and used four-minute repetitions. Shorter or
        longer repetitions may need a different rest.
      </p>

      <h2>How we use it</h2>
      <p>
        In PX7 Training the rest between intervals is its own part of the session, with a set
        duration and easy jogging. When you have less time, PX7 Training suggests a shorter
        version of the session instead of cutting the rest or the warm-up.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Seiler & Hetlelid (2005), The impact of rest duration on work intensity and RPE during
          interval training.{" "}
          <a href="https://doi.org/10.1249/01.mss.0000177560.18014.d8">Medicine & Science in Sports & Exercise</a>.
        </li>
      </ul>
    </>
  );
}
